module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ibox', [_c('template', {
    slot: "title"
  }, [_vm._v("口コミ詳細")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('review-form', {
    attrs: {
      "id": _vm.reviewId
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95a06e52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/review/Edit.vue
// module id = 476
// module chunks = 1